import { toast, useActivityTracker } from '@nile/components'
import { UpgradeLicenseSheet } from '@nile/components/src/Sheets'
import {
  AccountClient,
  UPGRADE_SUBSCRIPTION_STATUS,
  UPGRADE_SUBSCRIPTION
} from '@nile/graphql'
import { Modal, DisplayText } from '@superops/ui-design-system'
import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { isEmpty, omit } from 'lodash'
import PlanNameInfoCard from './PlanNameInfoCard'
import { ModalTitleWrapper } from './styles'
import ModifyTechnician from './ModifyTechnician'
import ManageAssetModal from './ManageAssetModal'
import ItPlanPurchase from '@nile/banyan/src/Pages/Protected/Configuration/Pricing/ItPlanPurchase'
import ItOverageDeviceList from '@nile/banyan/src/Pages/Protected/Configuration/Pricing/ITOverageDevice'

const AddTechEndpoint = (props) => {
  const {
    active,
    handleClose,
    subscription,
    plan,
    tenure,
    currency,
    locale,
    setTenure,
    isITProduct,
    overageBillingPeriod,
    intl,
    isTieredModel
  } = props

  const [openManageTechModal, setOpenManageTechModal] = useState(false)
  const [openManageAssetModal, setOpenManageAssetModal] = useState(false)
  const [openOverageAssetModal, setOpenOverageAssetModal] = useState(false)

  const handleManageModal = useCallback((type) => {
    if (type === 'TECHNICIAN') {
      setOpenManageTechModal((prevState) => !prevState)
    }
    if (type === 'NETWORK_ASSET') {
      setOpenManageAssetModal((prevState) => !prevState)
    }
  }, [])

  const onUpgradeHandler = (planEstimate, licenseCount) => {
    const chargebeeInstance = window.Chargebee.getInstance()
    chargebeeInstance.openCheckout({
      hostedPage: function () {
        return AccountClient.mutate({
          mutation: UPGRADE_SUBSCRIPTION,
          variables: {
            input: {
              chargeBeePlanPriceId:
                planEstimate?.plan?.planPrice?.chargeBeePlanPriceId,
              addons: !isEmpty(planEstimate?.addons)
                ? planEstimate?.addons
                    .map((el) =>
                      licenseCount[el?.addonPrice?.chargeBeeAddonPriceId]
                        ? {
                            chargeBeeAddonPriceId:
                              el?.addonPrice?.chargeBeeAddonPriceId,
                            quantity:
                              licenseCount[
                                el?.addonPrice?.chargeBeeAddonPriceId
                              ]
                          }
                        : null
                    )
                    .filter((el) => el)
                : [],
              quantity: licenseCount?.TECHNICIAN
            }
          }
        }).then((res) => {
          useActivityTracker({
            event: 'Inproduct purchase',
            data: {
              source: 'proceed to payment upgrade',
              subscription:
                subscription?.currentPlanPrice?.chargeBeePlanPriceId,
              techCount: licenseCount.TECHNICIAN,
              endpointCount: omit(licenseCount, 'TECHNICIAN')
            }
          })
          if (res?.data?.upgradeSubscription) {
            return res.data.upgradeSubscription
          }
        })
      },
      success: function () {
        AccountClient.mutate({
          mutation: UPGRADE_SUBSCRIPTION_STATUS,
          variables: {
            input: {
              status: 'SUCCESS'
            }
          }
        }).then((res) => {
          if (res?.data?.updateSubscriptionPurchaseStatus) {
            useActivityTracker({
              event: 'Inproduct purchase',
              data: {
                source: 'upgrade payment conformation',
                subscription:
                  subscription?.currentPlanPrice?.chargeBeePlanPriceId,
                techCount: licenseCount.TECHNICIAN,
                endpointCount: omit(licenseCount, 'TECHNICIAN')
              }
            })
            toast('success', 'Payment successful')
            chargebeeInstance.closeAll()
            window.location.reload()
          } else {
            useActivityTracker({
              event: 'Inproduct purchase',
              data: {
                source: 'Purchase plan payment inprogress',
                subscription:
                  subscription?.currentPlanPrice?.chargeBeePlanPriceId,
                techCount: licenseCount?.TECHNICIAN,
                endpointCount: omit(licenseCount, 'TECHNICIAN')
              }
            })
            chargebeeInstance.closeAll()
            window.location.reload()
          }
        })
      },
      close: function () {
        AccountClient.mutate({
          mutation: UPGRADE_SUBSCRIPTION_STATUS,
          variables: {
            input: {
              status: 'CANCEL'
            }
          }
        }).then((res) => {
          if (res?.data?.updateSubscriptionPurchaseStatus) {
            useActivityTracker({
              event: 'Inproduct purchase',
              data: {
                source: 'E. Payment cancelled',
                subscription:
                  subscription?.currentPlanPrice?.chargeBeePlanPriceId,
                techCount: licenseCount.TECHNICIAN
              }
            })
          }
          chargebeeInstance.closeAll()
        })
      }
    })
  }
  return isITProduct || isTieredModel ? (
    <Modal open={active} large showCloseButton={false}>
      <div
        className={`fh ${openOverageAssetModal ? 'hiddenActions' : 'block'}`}
      >
        <ItPlanPurchase
          handleClose={() => {
            handleClose(false)
          }}
          selectedPlan={subscription?.currentPlanPrice?.plan}
          tenure={tenure}
          currency={currency}
          locale={locale}
          intl={intl}
          subscription={subscription}
          setTenure={setTenure}
          openOverageAssetModal={openOverageAssetModal}
          setOpenOverageAssetModal={setOpenOverageAssetModal}
          isUpgrade
          isTieredModel={isTieredModel}
        />
      </div>
      {openOverageAssetModal && (
        <div className='vh90'>
          <ItOverageDeviceList
            openOverageAssetModal={openOverageAssetModal}
            setOpenOverageAssetModal={setOpenOverageAssetModal}
            overageBillingPeriod={overageBillingPeriod}
          />
        </div>
      )}
    </Modal>
  ) : (
    <>
      {!openManageTechModal && !openManageAssetModal && (
        <Modal
          open={active}
          onClose={() => handleClose(false)}
          title={
            <ModalTitleWrapper>
              <div className='modal-title'>
                <DisplayText element='h1' weight='Bold'>
                  <FormattedMessage id='admin.billing.upgradelicense.title' />
                </DisplayText>
              </div>
            </ModalTitleWrapper>
          }
          medium
        >
          <Modal.Section>
            <>
              <PlanNameInfoCard
                plan={plan}
                tenure={tenure}
                hideDescription
                setTenure={setTenure}
                subscription={subscription}
              />
              <UpgradeLicenseSheet
                subscription={subscription}
                plan={plan}
                tenure={tenure}
                currency={currency}
                locale={locale}
                onUpgradeHandler={onUpgradeHandler}
                handleManageModal={handleManageModal}
                isSamePlan
                superTip={
                  <FormattedMessage id='admin.billing.upgradeplan.superTip' />
                }
                isAddEndTech
              />
            </>
          </Modal.Section>
        </Modal>
      )}
      {openManageTechModal && (
        <Modal large open showCloseButton={false}>
          <ModifyTechnician closePage={handleManageModal} />
        </Modal>
      )}
      {openManageAssetModal && (
        <Modal large open showCloseButton={false}>
          <ManageAssetModal closePage={handleManageModal} />
        </Modal>
      )}
    </>
  )
}

export default withRouter(AddTechEndpoint)
